import { error, primary, secondary } from 'assets/colors/colors';
import { DialogComponentProps } from './type';
import { DialogTitle as MuiDialogTitle } from 'components/base/feedback/Dialog';
import { styled, SxProps } from 'components/base/system/style';

export const dialogTitleStyle: SxProps = {
  padding: '0 24px',
};

const getTitleColor: Record<
  NonNullable<DialogComponentProps['variant']>,
  string
> = {
  primary: secondary.main,
  error: error.main,
  secondary: primary.main,
};

export const StyledDialogTitle = styled(MuiDialogTitle, {
  shouldForwardProp: (prop) => prop !== '$variant',
})<{
  $variant: DialogComponentProps['variant'];
}>(({ $variant }) => ({
  padding: '16px 24px',
  fontSize: '1rem',
  color: getTitleColor[$variant!],
}));
